import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CardLayout from '@/layouts/CardLayout.vue';
import Background from '@/components/Background.vue';
import Next from '@/components/Next.vue';
import CounterButton from '@/components/CounterButton.vue';
import MiniCart from '@/components/MiniCart.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import CommonHeader from '@/components/CommonHeader.vue';
import CommentsButton from '@/components/CommentsButton.vue';
import LikeButton from '@/components/LikeButton.vue';
import { localizedProductPrice } from '../mixins/MenuLocalization';
import VariableLogo from '@/components/VariableLogo.vue';
let Category = class Category extends Vue {
    constructor() {
        super(...arguments);
        this.products = [];
        this.category = null;
        this.user = this.$store.state.user;
        this.showReviews = false;
    }
    seeProduct(productId) {
        this.$router.push('/products/' + productId);
    }
    seeReviews(productId) {
        this.$router.push('/reviews/' + productId);
    }
    getProductsOfCategory(categoryId) {
        const products = this.$store.getters.products;
        return products
            .filter(p => p.categoryId == categoryId && localizedProductPrice(p))
            .sort((c, n) => c.order - n.order);
    }
    getCategory(categoryId) {
        const categories = this.$store.getters.categories;
        const category = categories.find(c => c.id == categoryId);
        return category || null;
    }
    created() {
        this.products = this.getProductsOfCategory(this.$route.params.categoryId);
        this.category = this.getCategory(this.$route.params.categoryId);
        this.showReviews = this.$store.state.menu ? this.$store.state.menu.showReviews : false;
        if (this.category) {
            this.$analytics.logEvent('view_item_list', {
                item_list_name: this.category.name,
                item_list_id: this.category.id
            });
        }
    }
};
Category = __decorate([
    Component({
        components: {
            Background,
            VariableLogo,
            CardLayout,
            CommonHeader,
            Next,
            CounterButton,
            Thumbnail,
            SpinnerHolder,
            MiniCart,
            LikeButton,
            CommentsButton
        }
    })
], Category);
export default Category;
